import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import React, { useEffect } from 'react';
import PriceQuoteCaliforniaContent from './content/PriceQuoteCaliforniaContent';


function PriceQuoteCalifornia() {

    useEffect(() => {
        // Change Tab Title
        document.title = "Price Quote California - Insurance Enterprise"
    }, [])

    return (
        <>
            <PageLayout
                content={
                    <>
                        <SectionLayout content={<PriceQuoteCaliforniaContent />} />
                    </>
                }
            />
        </>
    )
}

export default PriceQuoteCalifornia
